// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IAutoInvestmentRuleDto } from './IAutoInvestmentRuleDto';
import {
    IAutoInvestmentRuleDtoFromJSON,
    IAutoInvestmentRuleDtoFromJSONTyped,
    IAutoInvestmentRuleDtoToJSON,
    IAutoInvestmentRuleDtoToJSONTyped,
} from './IAutoInvestmentRuleDto';

/**
 * 
 * @export
 * @interface IAutoInvestmentSchedulerResponseDto
 */
export interface IAutoInvestmentSchedulerResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IAutoInvestmentSchedulerResponseDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IAutoInvestmentSchedulerResponseDto
     */
    account_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IAutoInvestmentSchedulerResponseDto
     */
    investor_account_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IAutoInvestmentSchedulerResponseDto
     */
    amount_to_keep?: number;
    /**
     * 
     * @type {string}
     * @memberof IAutoInvestmentSchedulerResponseDto
     */
    status?: IAutoInvestmentSchedulerResponseDtoStatusEnum;
    /**
     * 
     * @type {Array<IAutoInvestmentRuleDto>}
     * @memberof IAutoInvestmentSchedulerResponseDto
     */
    auto_investment_rules?: Array<IAutoInvestmentRuleDto>;
}

/**
* @export
* @enum {string}
*/
export enum IAutoInvestmentSchedulerResponseDtoStatusEnum {
    ACTIVE = 'ACTIVE',
    PAUSED = 'PAUSED'
}


/**
 * Check if a given object implements the IAutoInvestmentSchedulerResponseDto interface.
 */
export function instanceOfIAutoInvestmentSchedulerResponseDto(value: object): value is IAutoInvestmentSchedulerResponseDto {
    return true;
}

export function IAutoInvestmentSchedulerResponseDtoFromJSON(json: any): IAutoInvestmentSchedulerResponseDto {
    return IAutoInvestmentSchedulerResponseDtoFromJSONTyped(json, false);
}

export function IAutoInvestmentSchedulerResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAutoInvestmentSchedulerResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'account_id': json['account_id'] == null ? undefined : json['account_id'],
        'investor_account_id': json['investor_account_id'] == null ? undefined : json['investor_account_id'],
        'amount_to_keep': json['amount_to_keep'] == null ? undefined : json['amount_to_keep'],
        'status': json['status'] == null ? undefined : json['status'],
        'auto_investment_rules': json['auto_investment_rules'] == null ? undefined : ((json['auto_investment_rules'] as Array<any>).map(IAutoInvestmentRuleDtoFromJSON)),
    };
}

export function IAutoInvestmentSchedulerResponseDtoToJSON(json: any): IAutoInvestmentSchedulerResponseDto {
    return IAutoInvestmentSchedulerResponseDtoToJSONTyped(json, false);
}

export function IAutoInvestmentSchedulerResponseDtoToJSONTyped(value?: IAutoInvestmentSchedulerResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'account_id': value['account_id'],
        'investor_account_id': value['investor_account_id'],
        'amount_to_keep': value['amount_to_keep'],
        'status': value['status'],
        'auto_investment_rules': value['auto_investment_rules'] == null ? undefined : ((value['auto_investment_rules'] as Array<any>).map(IAutoInvestmentRuleDtoToJSON)),
    };
}

